import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
import axios from 'axios';



const TwoFactor = ({ onLogin, userLang, prompt }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
const [loading, setLoading] = useState(false);
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
const { t } = useTranslation();

  useEffect(() => {
    if (!localStorage.getItem('tempToken')) {
      navigate('/connexion');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (code.length !== 6) {
      setError('Code invalide');
      return;
    }

    try {
      const tempToken = localStorage.getItem('tempToken');
const response = await api.post(
  '/api/users/login/2fa',
  { code },
  { headers: { Authorization: `Bearer ${tempToken}` } }
);

      const { token, refreshToken, user } = response.data;

      // Stockage normal
      localStorage.removeItem('tempToken');
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('user', JSON.stringify(user));

      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
sessionStorage.setItem('resumeLogin', '1');
navigate('/connexion'); 
	    } catch (err) {
      const backendCode = err.response?.data?.code;
      setError(backendCode ? backendCode : 'Code incorrect');
    }
  };

  return (
<div className="auth-container">

<div className="auth-form">
    <form onSubmit={handleSubmit} className="form-content">
      <div style={{display: 'flex'}}>
<h2>{t('2fa.verif')}</h2>
<span
  className="info-bubble"
  onClick={() =>
    prompt.alert(
      <span
        dangerouslySetInnerHTML={{
          __html: t('2fa.explication2')
        }}
      />
    )
  }
>
   <i className="ti ti-info-circle" style={{ fontSize: '16px', color: '#3498db' }} aria-hidden="true" />


  </span>
</div>


      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength="6"
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder={t('2fa.code')}
        autoFocus
	className="form-input"
      />

      <button type="submit" className="btn-primary">{t('2fa.valider')}</button>

      {error && <p className="error">{t('2fa.token_invalide')}</p>}
    </form>
</div>
</div>
  );
};
export default TwoFactor;